import { Area, PrstTxWarp, TransformLine } from '../../../type/common.interface';
import { textArchDownPour } from './text-arch-down-pour';
import { textArchUpPour } from './text-arch-up-pour';
import { textCanDown } from './text-can-down';
import { textCanUp } from './text-can-up';
import { textCascadeDown } from './text-cascade-down';
import { textCascadeUp } from './text-cascade-up';
import { textChevron } from './text-chevron';
import { textChevronInverted } from './text-chevron-inverted';
import { textCirclePour } from './text-circle-pour';
import { textCurveDown } from './text-curve-down';
import { textCurveUp } from './text-curve-up';
import { textDeflate } from './text-deflate';
import { textDeflateBottom } from './text-deflate-bottom';
import { textDeflateTop } from './text-deflate-top';
import { textDoubleWave1 } from './text-double-wave1';
import { textFadeDown } from './text-fade-down';
import { textFadeLeft } from './text-fade-left';
import { textFadeRight } from './text-fade-right';
import { textFadeUp } from './text-fade-up';
import { textInflate } from './text-inflate';
import { textInflateBottom } from './text-inflate-bottom';
import { textInflateTop } from './text-inflate-top';
import { textPlain } from './text-plain';
import { textRingInside } from './text-ring-inside';
import { textRingOutside } from './text-ring-outside';
import { textSlantDown } from './text-slant-down';
import { textSlantUp } from './text-slant-up';
import { textStop } from './text-stop';
import { textTriangle } from './text-triangle';
import { textTriangleInverted } from './text-triangle-inverted';
import { textWave1 } from './text-wave1';
import { textWave2 } from './text-wave2';
import { textWave4 } from './text-wave4';

// 所有定义的 warp 类型
// PBDEFAULT = 0
// textNoShape = 1
// textPlain = 2
// textStop = 3
// textTriangle = 4
// textTriangleInverted = 5
// textChevron = 6
// textChevronInverted = 7
// textRingInside = 8
// textRingOutside = 9
// textArchUp = 10
// textArchDown = 11
// textCircle = 12
// textButton = 13
// textArchUpPour = 14
// textArchDownPour = 15
// textCirclePour = 16
// textButtonPour = 17
// textCurveUp = 18
// textCurveDown = 19
// textCanUp = 20
// textCanDown = 21
// textWave1 = 22
// textWave2 = 23
// textDoubleWave1 = 24
// textWave4 = 25
// textInflate = 26
// textDeflate = 27
// textInflateBottom = 28
// textDeflateBottom = 29
// textInflateTop = 30
// textDeflateTop = 31
// textDeflateInflate = 32
// textDeflateInflateDeflate = 33
// textFadeRight = 34
// textFadeLeft = 35
// textFadeUp = 36
// textFadeDown = 37
// textSlantUp = 38
// textSlantDown = 39
// textCascadeUp = 40
// textCascadeDown = 41

const transformLinesMap = new Map<number, any>([
    [2, textPlain],
    [3, textStop],
    [4, textTriangle],
    [5, textTriangleInverted],
    [6, textChevron],
    [7, textChevronInverted],
    [8, textRingInside],
    [9, textRingOutside],
    [14, textArchUpPour],
    [15, textArchDownPour],
    [16, textCirclePour],
    [18, textCurveUp],
    [19, textCurveDown],
    [20, textCanUp],
    [21, textCanDown],
    [22, textWave1],
    [23, textWave2],
    [24, textDoubleWave1],
    [25, textWave4],
    [26, textInflate],
    [27, textDeflate],
    [28, textInflateBottom],
    [29, textDeflateBottom],
    [30, textInflateTop],
    [31, textDeflateTop],
    [34, textFadeRight],
    [35, textFadeLeft],
    [36, textFadeUp],
    [37, textFadeDown],
    [38, textSlantUp],
    [39, textSlantDown],
    [40, textCascadeUp],
    [41, textCascadeDown],
]);

export function transformLinesRouter(prstTxWarp: PrstTxWarp, area: Area): TransformLine[] {
    const getTransformLines = transformLinesMap.get(prstTxWarp.prst);

    if (getTransformLines) {
        return getTransformLines(prstTxWarp, area);
    }

    return [];
}
